import  Socket  from "../utils/Socket";
import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    eventSocket: new Socket(),
    accountSocket : new Socket(),
    usageSocket :new Socket(),

    loggedOut:false,

    limit:50,
    version:"0",
    delayTime:10,

    
    //timer:-1
  },
  mutations: {
    //store.commit('createSockets');
    createSockets(state){
      if (state.eventSocket===undefined || state.eventSocket===null || state.eventSocket.isConnected===false || state.eventSocket._socket.readyState=== 3){
          state.eventSocket =new Socket(process.env.VUE_APP_EVENTS_URL);
      }
      if(state.usageSocket===undefined || state.usageSocket===null || state.usageSocket.isConnected===false || state.usageSocket._socket.readyState=== 3){
          state.usageSocket=new Socket(process.env.VUE_APP_USAGE_URL);
      }
      if (state.accountSocket===undefined || state.accountSocket===null || state.accountSocket.isConnected===false || state.accountSocket._socket.readyState=== 3){
          state.accountSocket = new Socket(process.env.VUE_APP_ACCOUNTS_URL);
     }
     //console.log("checked ",state.timer);

    },

    closeSockets(state){
      //var _websocket = state.socket as Socket
      //_websocket.closeSocket();
      //if (state.socket instanceof WebSocket === false) { }

      if (state.eventSocket!==undefined && state.eventSocket!==null && state.eventSocket.isConnected===true){
        state.eventSocket.closeSocket();
      }
      if(state.usageSocket!==undefined && state.usageSocket!==null && state.usageSocket.isConnected===true){
        state.usageSocket.closeSocket();
      }
      if (state.accountSocket!==undefined && state.accountSocket!==null  && state.accountSocket.isConnected===true){
        state.accountSocket.closeSocket();
      }
//      clearInterval(state.timer);
//      state.timer=-1;
    },
  },
  actions: {
    //store.dispatch('createSocket')
    createSockets(context){
      context.commit('createSockets');
    },
    closeSockets(context){
      context.commit('closeSockets');
    },

    checkSockets(context,socket){
      if (context.state.loggedOut===false){
        const readyState=socket.readyState;
        if (readyState=== WebSocket.OPEN || readyState=== WebSocket.CONNECTING) {
          // do nothing
          console.log("already connected")
        } else if ( readyState=== WebSocket.CLOSED) {
          console.warn("CONNECTION IS: ",readyState );
          context.commit('createSockets');
        }
    }
    },
    updateVersion(context,version){
      context.state.version=version;

    },

    /*ticker(context){
      if( context.state.timer===-1 ){
        context.state.timer=setInterval(() => 	{
          context.commit('createSockets');
      }, 2000);
      console.log("new",context.state.timer);
      }else{
        console.log("old",context.state.timer);
      }    
    }*/

  },
  modules: {},
  

});
